import { useState, useEffect, useCallback } from 'react';
import type { AdminPermission, AdminStaffRole } from '@lighthouse/shared';
import { adminApi } from '../services/api';
import { useAdminAuth } from './useAdminAuth';

interface RbacMe {
  adminStaffRole: AdminStaffRole;
  permissions: AdminPermission[];
}

export function useAdminPermissions() {
  const { user } = useAdminAuth();
  const [adminStaffRole, setAdminStaffRole] = useState<AdminStaffRole | null>(null);
  const [permissions, setPermissions] = useState<AdminPermission[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setAdminStaffRole(null);
      setPermissions([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    adminApi<RbacMe>('/admin/rbac/me')
      .then((data) => {
        setAdminStaffRole(data.adminStaffRole);
        setPermissions(data.permissions);
      })
      .catch(() => {
        setAdminStaffRole(null);
        setPermissions([]);
      })
      .finally(() => setLoading(false));
  }, [user]);

  const hasPermission = useCallback(
    (permission: AdminPermission) => permissions.includes(permission),
    [permissions]
  );

  return { adminStaffRole, permissions, hasPermission, loading };
}
